export const student=[
  {
    "displayText": "CATEGORY WISE STUDENT LIST 2023-24 & 2024-25",
    "filename": "./assets/documentation/student/CATEGORY WISE STUDENT LIST 2023-24 & 2024-25.pdf",
    "link": ""
  },
  {
    "displayText": "CATEGORY WISE STUDENT LIST 2025-26",
    "filename": "./assets/documentation/student/CATEGORY WISE STUDENT LIST 2025-26.pdf",
    "link": ""
  },
  {
    "displayText": "RESULT 2024-25",
    "filename": "./assets/documentation/student/RESULT 2024-25.pdf",
    "link": ""
  },
  {
    "displayText": "Result 2015-2018",
    "filename": "./assets/documentation/student/Result 2015-2018.pdf",
    "link": ""
  },
  {
    "displayText": "Result 2020-2024",
    "filename": "./assets/documentation/student/Result 2020-2024.pdf",
    "link": ""
  }
]